"use client";

import { useState } from "react";

export function ShareButton({ name, trade }: { name: string; trade: string }) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const input = document.createElement("input");
      input.value = window.location.href;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  function handleWhatsApp() {
    const text = `Check out ${name} (${trade}) on Tradesfolk: ${window.location.href}`;
    window.open(
      `https://wa.me/?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  }

  function handleFacebook() {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`,
      "_blank"
    );
  }

  return (
    <div className="relative group">
      <button
        type="button"
        onClick={handleCopy}
        className="w-full px-4 py-3 border border-forest text-forest font-semibold rounded-sm hover:bg-sage-pale transition-all text-sm bg-transparent cursor-pointer font-sans flex items-center justify-center gap-2"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        {copied ? "Copied!" : "Share Profile"}
      </button>

      {/* Share options dropdown */}
      <div className="absolute top-full left-0 right-0 mt-1 bg-white rounded-lg shadow-[0_8px_30px_rgba(0,0,0,0.08)] overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
        <button
          onClick={handleWhatsApp}
          className="w-full px-4 py-3 text-sm text-text-body hover:bg-cream hover:text-forest text-left bg-transparent border-none cursor-pointer font-sans flex items-center gap-2"
        >
          WhatsApp
        </button>
        <button
          onClick={handleFacebook}
          className="w-full px-4 py-3 text-sm text-text-body hover:bg-cream hover:text-forest text-left bg-transparent border-none cursor-pointer font-sans flex items-center gap-2"
        >
          Facebook
        </button>
        <button
          onClick={handleCopy}
          className="w-full px-4 py-3 text-sm text-text-body hover:bg-cream hover:text-forest text-left bg-transparent border-none cursor-pointer font-sans flex items-center gap-2"
        >
          Copy Link
        </button>
      </div>
    </div>
  );
}
